import Apple from '../../assets/icons/apple.svg';
import ArrowBoxLeft from '../../assets/icons/arrow-box-left.svg';
import ArrowDownBrucke from '../../assets/icons/arrow-down-brucke.svg';
import ArrowDown from '../../assets/icons/arrow-down.svg';
import ArrowLeftBrucke from '../../assets/icons/arrow-left-brucke.svg';
import ArrowLeft from '../../assets/icons/arrow-left.svg';
import ArrowRightBrucke from '../../assets/icons/arrow-right-brucke.svg';
import ArrowRight from '../../assets/icons/arrow-right.svg';
import ArrowRotateLeftRight from '../../assets/icons/arrow-rotate-left-right.svg';
import ArrowShareRight from '../../assets/icons/arrow-share-right.svg';
import ArrowUpBrucke from '../../assets/icons/arrow-up-brucke.svg';
import ArrowUp from '../../assets/icons/arrow-up.svg';
import ArrowWallDown from '../../assets/icons/arrow-wall-down.svg';
import ArrowWallLeft from '../../assets/icons/arrow-wall-left.svg';
import ArrowWallRight from '../../assets/icons/arrow-wall-right.svg';
import ArrowWallUp from '../../assets/icons/arrow-wall-up.svg';
import ArrowRepeatRightLeft from '../../assets/icons/arrows-repeat-right-left.svg';
import Asterisk from '../../assets/icons/asterisk.svg';
import At from '../../assets/icons/at.svg';
import Audio from '../../assets/icons/audio.svg';
import Bank from '../../assets/icons/bank.svg';
import Banknote1 from '../../assets/icons/banknote-1.svg';
import Banknote2 from '../../assets/icons/banknote-2.svg';
import BarsThree from '../../assets/icons/bars-three.svg';
import Bell2 from '../../assets/icons/bell-2.svg';
import Bell from '../../assets/icons/bell.svg';
import BookmarkCheck from '../../assets/icons/bookmark-check.svg';
import Bookmark from '../../assets/icons/bookmark.svg';
import Bubble2 from '../../assets/icons/bubble-2.svg';
import BubbleQuestion from '../../assets/icons/bubble-question.svg';
import Calendar2 from '../../assets/icons/calendar-2.svg';
import Calendar3 from '../../assets/icons/calendar-3.svg';
import CalendarCheck4Filled from '../../assets/icons/calendar-check-4-filled.svg';
import CalendarCheck4 from '../../assets/icons/calendar-check-4.svg';
import CalendarEdit from '../../assets/icons/calendar-edit.svg';
import CalendarRemove from '../../assets/icons/calendar-remove.svg';
import Camera4 from '../../assets/icons/camera-4.svg';
import ChainLink3 from '../../assets/icons/chain-link-3.svg';
import Checkmark1Small from '../../assets/icons/checkmark-1-small.svg';
import Checkmark1 from '../../assets/icons/checkmark-1.svg';
import ChevronBottom from '../../assets/icons/chevron-bottom.svg';
import ChevronLeft from '../../assets/icons/chevron-left.svg';
import ChevronRight from '../../assets/icons/chevron-right.svg';
import ChevronTop from '../../assets/icons/chevron-top.svg';
import CircleCheck from '../../assets/icons/circle-check.svg';
import CircleDotted from '../../assets/icons/circle-dotted.svg';
import CircleInfo from '../../assets/icons/circle-info.svg';
import CirclePlus from '../../assets/icons/circle-plus.svg';
import CircleQuestionmark from '../../assets/icons/circle-questionmark.svg';
import CircleX from '../../assets/icons/circle-x.svg';
import Clipboard2 from '../../assets/icons/clipboard-2.svg';
import Clock from '../../assets/icons/clock.svg';
import CompassRound from '../../assets/icons/compass-round.svg';
import CreditCard1 from '../../assets/icons/credit-card-1.svg';
import CreditCard2 from '../../assets/icons/credit-card-2.svg';
import CreditCardAdd from '../../assets/icons/credit-card-add.svg';
import CrossLarge from '../../assets/icons/cross-large.svg';
import CrossSmall from '../../assets/icons/cross-small.svg';
import Crown from '../../assets/icons/crown.svg';
import Cryptopunk from '../../assets/icons/cryptopunk.svg';
import Devices from '../../assets/icons/devices.svg';
import DiamondShine from '../../assets/icons/diamond-shine.svg';
import DotGrid1x3Horizontal from '../../assets/icons/dot-grid-1x3-horizontal.svg';
import DotGrid1x3Vertical from '../../assets/icons/dot-grid-1x3-vertical.svg';
import DotGrid2x3 from '../../assets/icons/dot-grid-2x3.svg';
import DotGrid3x3 from '../../assets/icons/dot-grid-3x3.svg';
import Earth from '../../assets/icons/earth.svg';
import EditSmall1 from '../../assets/icons/edit-small-1.svg';
import Email2 from '../../assets/icons/email-2.svg';
import EmailNotification from '../../assets/icons/email-notification.svg';
import EmojiAlt from '../../assets/icons/emoji-alt.svg';
import EmojiArc from '../../assets/icons/emoji-arc.svg';
import EmojiSad from '../../assets/icons/emoji-sad.svg';
import EmojiSleep from '../../assets/icons/emoji-sleep.svg';
import EmojiSmile from '../../assets/icons/emoji-smile.svg';
import EmojiSmiley from '../../assets/icons/emoji-smiley.svg';
import EmojiSmilingFace from '../../assets/icons/emoji-smiling-face.svg';
import EyeOpen from '../../assets/icons/eye-open.svg';
import EyeSlash from '../../assets/icons/eye-slash.svg';
import FaceId from '../../assets/icons/face-id.svg';
import Fashion from '../../assets/icons/fashion.svg';
import Feature from '../../assets/icons/feature.svg';
import FilePdf from '../../assets/icons/file-pdf.svg';
import Filter1 from '../../assets/icons/filter-1.svg';
import FilterAsc from '../../assets/icons/filter-asc.svg';
import FilterAscending from '../../assets/icons/filter-ascending.svg';
import FilterDescending from '../../assets/icons/filter-descending.svg';
import FilterTimeline from '../../assets/icons/filter-timeline.svg';
import FingerPrint1 from '../../assets/icons/finger-print-1.svg';
import Fire2 from '../../assets/icons/fire-2.svg';
import Fire3 from '../../assets/icons/fire-3.svg';
import Fistbump from '../../assets/icons/fistbump.svg';
import Flag1 from '../../assets/icons/flag-1.svg';
import Flag2 from '../../assets/icons/flag-2.svg';
import Ghost from '../../assets/icons/ghost.svg';
import Globus from '../../assets/icons/globus.svg';
import Google from '../../assets/icons/google.svg';
import Group from '../../assets/icons/group.svg';
import HeartFilled from '../../assets/icons/heart-filled.svg';
import Heart from '../../assets/icons/heart.svg';
import HomeDoor from '../../assets/icons/home-door.svg';
import HomeRoof from '../../assets/icons/home-roof.svg';
import Hourglass from '../../assets/icons/hourglass.svg';
import Instagram from '../../assets/icons/instagram.svg';
import Loader from '../../assets/icons/loader.svg';
import Lock from '../../assets/icons/lock.svg';
import Macbook from '../../assets/icons/macbook.svg';
import MagnifyingGlass from '../../assets/icons/magnifying-glass.svg';
import MapPin from '../../assets/icons/map-pin.svg';
import MedicineTablett from '../../assets/icons/medicine-tablett.svg';
import MinusLarge from '../../assets/icons/minus-large.svg';
import MinusSmall from '../../assets/icons/minus-small.svg';
import NoConnection from '../../assets/icons/no-connection.svg';
import PageEditText from '../../assets/icons/page-edit-text.svg';
import PageText from '../../assets/icons/page-text.svg';
import PaperPlaneTopRight from '../../assets/icons/paper-plane-top-right.svg';
import Paperclip1 from '../../assets/icons/paperclip-1.svg';
import Parachute from '../../assets/icons/parachute.svg';
import Password from '../../assets/icons/password.svg';
import Pencil from '../../assets/icons/pencil.svg';
import PeopleAdd2 from '../../assets/icons/people-add-2.svg';
import PeopleAdd from '../../assets/icons/people-add.svg';
import PeopleAdded from '../../assets/icons/people-added.svg';
import PeopleRemove from '../../assets/icons/people-remove.svg';
import PhoneDynamicIsland from '../../assets/icons/phone-dynamic-island.svg';
import PinFlag from '../../assets/icons/pin-flag.svg';
import Planning from '../../assets/icons/planning.svg';
import Playlist from '../../assets/icons/playlist.svg';
import PlusLarge from '../../assets/icons/plus-large.svg';
import PlusSmall from '../../assets/icons/plus-small.svg';
import RaisingHand4Finger from '../../assets/icons/raising-hand-4-finger.svg';
import SettingsGear2 from '../../assets/icons/settings-gear-2.svg';
import SettingsSliderHor from '../../assets/icons/settings-slider-hor.svg';
import SettingsSliderThree from '../../assets/icons/settings-slider-three.svg';
import Shaka1 from '../../assets/icons/shaka-1.svg';
import ShieldCheck from '../../assets/icons/shield-check.svg';
import Sleep from '../../assets/icons/sleep.svg';
import SparklesTwo from '../../assets/icons/sparkles-two.svg';
import Spotify from '../../assets/icons/spotify.svg';
import SquareArrowTopRight from '../../assets/icons/square-arrow-top-right.svg';
import SquareBehindSquare2 from '../../assets/icons/square-behind-square-2.svg';
import SquareCheckFilled from '../../assets/icons/square-check-filled.svg';
import SquareCheck from '../../assets/icons/square-check.svg';
import SquareInfoFilled from '../../assets/icons/square-info-filled.svg';
import SquareInfo from '../../assets/icons/square-info.svg';
import SquareLinesBottom from '../../assets/icons/square-lines-bottom.svg';
import SquarePlaceholderDashed from '../../assets/icons/square-placeholder-dashed.svg';
import SquarePlus from '../../assets/icons/square-plus.svg';
import SquareXFilled from '../../assets/icons/square-x-filled.svg';
import SquareX from '../../assets/icons/square-x.svg';
import StarFilled from '../../assets/icons/star-filled.svg';
import Star from '../../assets/icons/star.svg';
import Tag from '../../assets/icons/tag.svg';
import TargetArrow from '../../assets/icons/target-arrow.svg';
import Threads from '../../assets/icons/threads.svg';
import ThumbDownCurvedFilled from '../../assets/icons/thumb-down-curved-filled.svg';
import ThumbDownCurved from '../../assets/icons/thumb-down-curved.svg';
import ThumbUpCurvedFilled from '../../assets/icons/thumb-up-curved-filled.svg';
import ThumbUpCurved from '../../assets/icons/thumb-up-curved.svg';
import Thumbtack from '../../assets/icons/thumbtack.svg';
import Ticket from '../../assets/icons/ticket.svg';
import Tiktok from '../../assets/icons/tiktok.svg';
import TouchGrass from '../../assets/icons/touch-grass.svg';
import TrashCanSimple from '../../assets/icons/trash-can-simple.svg';
import TrashCan from '../../assets/icons/trash-can.svg';
import TriangleExclamationFilled from '../../assets/icons/triangle-exclamation-filled.svg';
import TriangleExclamation from '../../assets/icons/triangle-exclamation.svg';
import Trophy from '../../assets/icons/trophy.svg';
import Unlocked from '../../assets/icons/unlocked.svg';
import VentiSwap from '../../assets/icons/venti-swap.svg';
import Venti from '../../assets/icons/venti.svg';
import VolumeDown from '../../assets/icons/volume-down.svg';
import VolumeFull from '../../assets/icons/volume-full.svg';
import VolumeHalf from '../../assets/icons/volume-half.svg';
import VolumeMinimum from '../../assets/icons/volume-minimum.svg';
import VolumeOff from '../../assets/icons/volume-off.svg';
import VolumeUp from '../../assets/icons/volume-up.svg';
import Wallet3 from '../../assets/icons/wallet-3.svg';
import Wallet4 from '../../assets/icons/wallet-4.svg';
import Wreath from '../../assets/icons/wreath.svg';
import X from '../../assets/icons/x.svg';
import Youtube from '../../assets/icons/youtube.svg';
import ZoomIn from '../../assets/icons/zoom-in.svg';
import ZoomOut from '../../assets/icons/zoom-out.svg';

export const ICONS_MAP = {
  apple: Apple,
  'arrow-box-left': ArrowBoxLeft,
  'arrow-down': ArrowDown,
  'arrow-down-brucke': ArrowDownBrucke,
  'arrow-left': ArrowLeft,
  'arrow-left-brucke': ArrowLeftBrucke,
  'arrows-repeat-right-left': ArrowRepeatRightLeft,
  'arrow-right': ArrowRight,
  'arrow-right-brucke': ArrowRightBrucke,
  'arrow-rotate-left-right': ArrowRotateLeftRight,
  'arrow-share-right': ArrowShareRight,
  'arrow-up': ArrowUp,
  'arrow-up-brucke': ArrowUpBrucke,
  'arrow-wall-down': ArrowWallDown,
  'arrow-wall-left': ArrowWallLeft,
  'arrow-wall-right': ArrowWallRight,
  'arrow-wall-up': ArrowWallUp,
  asterisk: Asterisk,
  at: At,
  audio: Audio,
  bank: Bank,
  'banknote-1': Banknote1,
  'banknote-2': Banknote2,
  'bars-three': BarsThree,
  'bell-2': Bell2,
  bell: Bell,
  'bookmark-check': BookmarkCheck,
  bookmark: Bookmark,
  'bubble-2': Bubble2,
  'bubble-question': BubbleQuestion,
  'calendar-2': Calendar2,
  'calendar-3': Calendar3,
  'calendar-check-4-filled': CalendarCheck4Filled,
  'calendar-check-4': CalendarCheck4,
  'calendar-edit': CalendarEdit,
  'calendar-remove': CalendarRemove,
  'camera-4': Camera4,
  'chain-link-3': ChainLink3,
  'checkmark-1-small': Checkmark1Small,
  'checkmark-1': Checkmark1,
  'chevron-bottom': ChevronBottom,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevron-top': ChevronTop,
  'circle-check': CircleCheck,
  'circle-dotted': CircleDotted,
  'circle-info': CircleInfo,
  'circle-plus': CirclePlus,
  'circle-questionmark': CircleQuestionmark,
  'circle-x': CircleX,
  'clipboard-2': Clipboard2,
  clock: Clock,
  'compass-round': CompassRound,
  'credit-card-1': CreditCard1,
  'credit-card-2': CreditCard2,
  'credit-card-add': CreditCardAdd,
  'cross-large': CrossLarge,
  'cross-small': CrossSmall,
  crown: Crown,
  cryptopunk: Cryptopunk,
  devices: Devices,
  'diamond-shine': DiamondShine,
  'dot-grid-1x3-horizontal': DotGrid1x3Horizontal,
  'dot-grid-1x3-vertical': DotGrid1x3Vertical,
  'dot-grid-2x3': DotGrid2x3,
  'dot-grid-3x3': DotGrid3x3,
  earth: Earth,
  'edit-small-1': EditSmall1,
  'email-2': Email2,
  'email-notification': EmailNotification,
  'emoji-alt': EmojiAlt,
  'emoji-arc': EmojiArc,
  'emoji-sad': EmojiSad,
  'emoji-sleep': EmojiSleep,
  'emoji-smile': EmojiSmile,
  'emoji-smiley': EmojiSmiley,
  'emoji-smiling-face': EmojiSmilingFace,
  'eye-open': EyeOpen,
  'eye-slash': EyeSlash,
  'face-id': FaceId,
  fashion: Fashion,
  feature: Feature,
  'file-pdf': FilePdf,
  'filter-1': Filter1,
  'filter-asc': FilterAsc,
  'filter-ascending': FilterAscending,
  'filter-descending': FilterDescending,
  'filter-timeline': FilterTimeline,
  'finger-print-1': FingerPrint1,
  'fire-2': Fire2,
  'fire-3': Fire3,
  fistbump: Fistbump,
  'flag-1': Flag1,
  'flag-2': Flag2,
  ghost: Ghost,
  globus: Globus,
  google: Google,
  group: Group,
  'heart-filled': HeartFilled,
  heart: Heart,
  'home-door': HomeDoor,
  'home-roof': HomeRoof,
  hourglass: Hourglass,
  instagram: Instagram,
  loader: Loader,
  lock: Lock,
  macbook: Macbook,
  'magnifying-glass': MagnifyingGlass,
  'map-pin': MapPin,
  'medicine-tablett': MedicineTablett,
  'minus-large': MinusLarge,
  'minus-small': MinusSmall,
  'no-connection': NoConnection,
  'page-edit-text': PageEditText,
  'page-text': PageText,
  'paper-plane-top-right': PaperPlaneTopRight,
  'paperclip-1': Paperclip1,
  parachute: Parachute,
  password: Password,
  pencil: Pencil,
  'people-add-2': PeopleAdd2,
  'people-add': PeopleAdd,
  'people-added': PeopleAdded,
  'people-remove': PeopleRemove,
  'phone-dynamic-island': PhoneDynamicIsland,
  'pin-flag': PinFlag,
  planning: Planning,
  playlist: Playlist,
  'plus-large': PlusLarge,
  'plus-small': PlusSmall,
  'raising-hand-4-finger': RaisingHand4Finger,
  'settings-gear-2': SettingsGear2,
  'settings-slider-hor': SettingsSliderHor,
  'settings-slider-three': SettingsSliderThree,
  'shaka-1': Shaka1,
  'shield-check': ShieldCheck,
  sleep: Sleep,
  'sparkles-two': SparklesTwo,
  spotify: Spotify,
  'square-arrow-top-right': SquareArrowTopRight,
  'square-behind-square-2': SquareBehindSquare2,
  'square-check-filled': SquareCheckFilled,
  'square-check': SquareCheck,
  'square-info-filled': SquareInfoFilled,
  'square-info': SquareInfo,
  'square-lines-bottom': SquareLinesBottom,
  'square-placeholder-dashed': SquarePlaceholderDashed,
  'square-plus': SquarePlus,
  'square-x-filled': SquareXFilled,
  'square-x': SquareX,
  'star-filled': StarFilled,
  star: Star,
  tag: Tag,
  'target-arrow': TargetArrow,
  threads: Threads,
  'thumb-down-curved-filled': ThumbDownCurvedFilled,
  'thumb-down-curved': ThumbDownCurved,
  'thumb-up-curved-filled': ThumbUpCurvedFilled,
  'thumb-up-curved': ThumbUpCurved,
  thumbtack: Thumbtack,
  ticket: Ticket,
  tiktok: Tiktok,
  'touch-grass': TouchGrass,
  'trash-can-simple': TrashCanSimple,
  'trash-can': TrashCan,
  'triangle-exclamation-filled': TriangleExclamationFilled,
  'triangle-exclamation': TriangleExclamation,
  trophy: Trophy,
  unlocked: Unlocked,
  venti: Venti,
  'venti-swap': VentiSwap,
  'volume-down': VolumeDown,
  'volume-full': VolumeFull,
  'volume-half': VolumeHalf,
  'volume-minimum': VolumeMinimum,
  'volume-off': VolumeOff,
  'volume-up': VolumeUp,
  'wallet-3': Wallet3,
  'wallet-4': Wallet4,
  wreath: Wreath,
  x: X,
  youtube: Youtube,
  'zoom-in': ZoomIn,
  'zoom-out': ZoomOut,
};

export const DEFAULT_ICON_SIZE = 24;
